'use client';

import { useEffect } from 'react';
import { reportClientError } from '@/app/lib/analytics';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportClientError(error);
  }, [error]);

  return (
    <html lang="ru">
      <body>
        <div
          className="bg-dark text-white"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            textAlign: 'center',
            padding: '1rem',
            gap: '1rem',
          }}
        >
          <h1>Что-то пошло не так</h1>
          <p>Попробуйте обновить страницу.</p>
          <button onClick={reset}>Попробовать снова</button>
        </div>
      </body>
    </html>
  );
}
